/* Notifications dropdown loader — avoids Alpine x-show (rAF) and a Turbo
 * renderStreamMessage path that trips Alpine's tickStack under WebGL load.
 * Called from the header bell button when the panel opens.
 */

function extractNotificationsView(html) {
    const match = html.match(
        /<turbo-stream[^>]*\btarget=["']notifications-view["'][^>]*>\s*<template>([\s\S]*?)<\/template>\s*<\/turbo-stream>/i
    );
    if (!match) return null;
    const wrap = document.createElement("div");
    wrap.innerHTML = match[1].trim();
    return wrap.querySelector("#notifications-view");
}

export async function loadNotificationsDropdown() {
    const res = await fetch("/notifications", {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin",
    });
    if (!res.ok) return;
    const html = await res.text();
    const next = extractNotificationsView(html);
    const cur = document.getElementById("notifications-view");
    if (!next || !cur) return;
    cur.replaceWith(next);
    if (window.Alpine) {
        window.Alpine.initTree(document.getElementById("notifications-view"));
    }
}

export function initNotificationsMenu() {
    document.addEventListener("click", (ev) => {
        const btn = ev.target.closest && ev.target.closest("[data-sm-notif-toggle]");
        if (!btn) return;
        // Alpine toggles open state via @click on the same button; load after
        // the microtask so notificationsDropdownOpen is already true.
        queueMicrotask(() => {
            const nav = document.querySelector(".cg-header__nav");
            const open = nav && nav._x_dataStack && nav._x_dataStack[0] && nav._x_dataStack[0].notificationsDropdownOpen;
            if (open) loadNotificationsDropdown();
        });
    });
}

export default initNotificationsMenu;
